export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/IQ-6a80ee0ddeb3274aa98b31ac706ba853.png";